"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import type { CarouselProgressProps } from "./types";

/**
 * Story-like progress bars for carousels
 */
export const CarouselProgress = React.forwardRef<
  HTMLDivElement,
  CarouselProgressProps
>(({ total, current, progress, className }, ref) => {
  if (total <= 0) return null;

  return (
    <div ref={ref} className={cn("flex gap-1 w-full px-4 py-3", className)}>
      {Array.from({ length: total }).map((_, index) => {
        let barProgress = 0;

        if (index < current) {
          barProgress = 100;
        } else if (index === current) {
          barProgress = progress;
        }

        return (
          <div
            key={index}
            className="flex-1 h-0.5 bg-white/30 rounded-full overflow-hidden"
          >
            <div
              className="h-full bg-white rounded-full transition-all duration-75 ease-linear"
              style={{ width: `${barProgress}%` }}
            />
          </div>
        );
      })}
    </div>
  );
});

CarouselProgress.displayName = "CarouselProgress";

